/**
 * @file rainbow配置
 * https://rainbow.woa.com/console/854678c1-4277-4616-9ea4-7b13938d8954/Default/list
 */

import Rainbow from '@tencent/rainbow-browser-sdk-lite';
import { IS_PRODUCTION } from '@/constants/config';

const APPID = '854678c1-4277-4616-9ea4-7b13938d8954';

export enum RainbowSchemaId {
  common_config = 'common_config',
  micro_app_config = 'micro_app_config',
}

const rainbow = new Rainbow({
  connectStr: 'https://oi.rb.qq.com', // Rainbow服务地址
});

const getRainbowParams = (group: string) => ({
  group,
  appID: APPID,
  envName: IS_PRODUCTION ? 'Default' : 'Test',
});

// 获取kv配置
const getKVConfig = async (schemaId: RainbowSchemaId, key: string) => {
  const res = await rainbow.get(key, getRainbowParams(schemaId));
  return JSON.parse(res);
};

// 获取table配置
const getTableConfig = async (schemaId: RainbowSchemaId) => {
  return await rainbow.getTable(getRainbowParams(schemaId));
};

// 通用配置
export const getRainbowCommonConfig = (key: string) => getKVConfig(RainbowSchemaId.common_config, key);

// 微应用配置
export const getRainbowMicroAppConfig = () => getTableConfig(RainbowSchemaId.micro_app_config);


